import { Repository } from "src/firebase/firestore/repository";
import { UserReport } from "../types/user-report.entity";

class UserReportRepository extends Repository<UserReport> {
  constructor() {
    super("reports");
  }
}

export const userReportRepository = new UserReportRepository();
